import { render } from "./ActiveCryptoNFRsV1.1.vue?vue&type=template&id=4d0dc9c8"
import script from "./ActiveCryptoNFRsV1.1.vue?vue&type=script&lang=js"
export * from "./ActiveCryptoNFRsV1.1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__